import React from "react";

import { Theme } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import DEFAULT_THEME from "./theme";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

type ThemeProviderProps = {
  children: React.ReactNode;
  theme?: Theme | ((theme: Theme) => Theme);
};

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
  if (typeof theme === "function") {
    // For merging themes
    return (
      <MuiThemeProvider theme={theme(DEFAULT_THEME)}>
        {children}
      </MuiThemeProvider>
    );
  }

  if (typeof theme === "object") {
    // For overriding the default theme
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }

  // For only using the default theme
  return <MuiThemeProvider theme={DEFAULT_THEME}>{children}</MuiThemeProvider>;
};

export default React.memo((props: ThemeProviderProps) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <ThemeProvider {...props} />
  </LocalizationProvider>
));
